// Forma da página enquanto carrega (cinzento animado), em vez da roda a girar
const Bar = ({ className = '' }) => <div className={`skeleton-shimmer rounded ${className}`} />;

export const RowsSkeleton = ({ rows = 6 }) => (
  <div className="rounded-[10px] border border-slate-700/80 bg-[#1E2126] divide-y divide-slate-800">
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="flex items-center gap-3 px-4 py-3.5">
        <Bar className="h-8 w-8 rounded-md flex-shrink-0" />
        <div className="flex-1 space-y-2">
          <Bar className="h-3 w-2/5" />
          <Bar className="h-2.5 w-1/4" />
        </div>
        <Bar className="h-4 w-16" />
      </div>
    ))}
  </div>
);

const PageSkeleton = ({ stats = 3, rows = 6 }) => (
  <div className="space-y-5" aria-busy="true" aria-label="A carregar">
    <div className="flex items-end justify-between gap-4">
      <div className="space-y-2">
        <Bar className="h-7 w-48" />
        <Bar className="h-3 w-64" />
      </div>
      <Bar className="h-9 w-32 rounded-md" />
    </div>
    {stats > 0 && (
      <div className={`grid gap-3 grid-cols-2 ${stats >= 4 ? 'lg:grid-cols-4' : 'lg:grid-cols-3'}`}>
        {Array.from({ length: stats }).map((_, i) => (
          <div key={i} className="rounded-[10px] border border-slate-700/80 bg-[#1E2126] p-4 space-y-3">
            <Bar className="h-2.5 w-20" />
            <Bar className="h-7 w-28" />
          </div>
        ))}
      </div>
    )}
    <RowsSkeleton rows={rows} />
  </div>
);

export default PageSkeleton;
